import { Component, OnInit, Input } from '@angular/core';
import { Entry } from 'contentful';

@Component({
  selector: 'app-hero-profile',
  templateUrl: './hero-profile.component.html',
  styleUrls: ['./hero-profile.component.scss']
})
export class HeroProfileComponent implements OnInit {
  @Input() public firstName: string;
  @Input() public hasSubscription: boolean;
  @Input() public content: Entry<any>;

  constructor() {}

  get heroTextIfUserHasActiveSubscription() {
    return this.content.fields.heroTextIfUserHasActiveSubscription.replace(
      '{{firstName}}',
      this.firstName
    );
  }

  ngOnInit() {}
}
